"use client"

import { getLinkIconById } from "@store-platform/launcher/utils"
import { LauncherLink } from "@store-platform/types"
import { Link } from "@store-platform/ui/common"
import { createElement } from "react"

export const ProfileSocialIcon = (props: { link: LauncherLink }) => {
  return (
    <Link
      key={props.link.url}
      variant="naked"
      href={props.link.url}
      className="flex items-center gap-0.5 group"
      asExternal
    >
      {createElement(getLinkIconById(props.link.iconId), {
        className: "text-blue-500 hover:text-blue-700",
      })}
    </Link>
  )
}
